module.exports = __webpack_public_path__ + "static/ImplementationStrategy-f398f3e17855a11d86a8eaad0ab73216.png";